import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface DeploymentRingFilterValues {
  name: string;
}

export const DeploymentRingFilter = ({ children }: PropsWithChildren<any>) => {
  const filterItems: Item<DeploymentRingFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<DeploymentRingFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
    >
      {children}
    </FilterBar>
  );
};
